import * as types from "../actionTypes";

export const setCostOfSaleContdByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_COST_OF_SALE_CONTD_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setCostOfSaleContdByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_COST_OF_SALE_CONTD_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceCostOfSaleContdYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_COST_OF_SALES_YEAR,
      key,
      payload,
    });
  };
};

export const setCostOfSaleContdInitialPeriod = (key, initialPeriod) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_COST_OF_SALE_CONTD_INITIAL_PERIOD,
      key,
      initialPeriod,
    });
  };
};

export const setCostOfSaleContdInitialPeriodMonth = (key, initialPeriod) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_COST_OF_SALE_CONTD_INITIAL_PERIOD_MONTH,
      key,
      initialPeriod,
    });
  };
};

export const replaceCostOfSaleContdYearsSecond = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_COST_OF_SALE_CONTD_YEARS,
      key,
      payload,
    });
  };
};

export const replaceCostOfSaleContdMonths = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_COST_OF_SALE_CONTD_MONTHS,
      key,
      payload,
    });
  };
};

export const resetCostOfSaleContdReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_COST_OF_SALE_CONTD_REDUCER,
    });
  };
};

export const resetCostOfSaleReducer = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_COST_OF_SALES_REDUCER,
    });
  };
};
